import styled from "styled-components";

export const LinkBox = styled.div`
  padding: 0.625rem 0.75rem;
  border: 1px solid #d1d5db;
  border-radius: 0.375rem;
  background-color: #f9fafb;
  font-size: 0.875rem;
  color: #111827;
  overflow-x: auto;
  white-space: nowrap;
`;

export const LinkActions = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  margin-top: 0.75rem;
  margin-bottom: 1.5rem;
`;

export const SecondaryLinkButton = styled.a`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.625rem 1rem;
  border: 1px solid #d1d5db;
  border-radius: 0.375rem;
  background-color: #ffffff;
  color: #111827;
  font-size: 0.875rem;
  font-weight: 500;
  text-decoration: none;
  white-space: nowrap;
  transition: background-color 0.2s;

  &:hover {
    background-color: #f3f4f6;
  }
`;

export const ReferredHeader = styled.div`
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 1rem;
`;

export const CreditsTotal = styled.span`
  font-size: 0.875rem;
  font-weight: 600;
  color: #111827;
`;

export const CreditsEarned = styled.span`
  font-size: 0.875rem;
  font-weight: 600;
  color: #15803d;
  white-space: nowrap;
`;

export const EmptyText = styled.p`
  font-size: 0.875rem;
  color: #6b7280;
  margin: 0;
`;
